import { AlertTriangle, CheckCircle, XCircle } from 'lucide-react';
import type { ConsentPillConfigEntry, ConsentStatus, DisplayedConsentStatus } from './ConsentStatusPill.types';

/** Visuals/copy for each consent status — shared by ConsentStatusPill and ConsentStatusControl. */
export const consentPillConfig: Record<DisplayedConsentStatus, ConsentPillConfigEntry> = {
  active: {
    icon: CheckCircle,
    label: 'Samþykki í gildi',
    description: 'Sjúklingur hefur undirritað rafrænt samþykki.',
    iconClass: 'text-green-600',
  },
  rejected: {
    icon: XCircle,
    label: 'Samþykki hafnað',
    description: 'Sjúklingur hefur hafnað rafrænu samþykki.',
    iconClass: 'text-red-600',
  },
  not_viewed: {
    icon: AlertTriangle,
    label: 'Samþykki óstaðfest',
    description: 'Rafrænt samþykki hefur ekki verið undirritað.',
    iconClass: 'text-amber-500',
  },
  error: {
    icon: AlertTriangle,
    label: 'Villa við að sækja samþykki',
    description: 'Ekki tókst að sækja stöðu samþykkis.',
    iconClass: 'text-gray-500',
  },
};

// 'unavailable' = the clinic has no published consent document, so no consent UI is shown.
export const getConsentPillConfig = (status: ConsentStatus | undefined): ConsentPillConfigEntry | undefined =>
  status && status !== 'unavailable' ? consentPillConfig[status] : undefined;
